import { render, staticRenderFns } from "./sidebar_menu_items.vue?vue&type=template&id=3ab4608b&"
import script from "./sidebar_menu_items.vue?vue&type=script&lang=js&"
export * from "./sidebar_menu_items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports